import type { SolarShareFixStep } from "~/api/dto/solar-presentation.dto"
import { getPowurUrl } from "~/utils/getUrlForEnvironment"

import { solarProposalPath, solarSetupStepPath } from "./solar-setup-paths"

/** The project's proposals on PowurOS, or its projects list without a project,
 * as V1's Back to Powur.com link does. The host is per environment. */
export const powurProposalsUrl = (powurProjectId: number | null): string =>
  powurProjectId
    ? `${getPowurUrl()}/projects/${powurProjectId}/proposals`
    : `${getPowurUrl()}/projects/`

/**
 * Where each blocker is fixed: the design step, Finance Partner & Equipment
 * (which owns the partner), Loan Product (which owns the Credit Human term), System Pricing (which owns Refresh Pricing), and the
 * presentation's savings section (which owns Recalculate savings).
 */
export const solarShareFixPath = (
  proposalId: string,
  step: SolarShareFixStep,
): string =>
  step === `savings`
    ? `${solarProposalPath(proposalId)}#savings`
    : solarSetupStepPath(proposalId, step)
